<template>
    <div class="page-table scrollable only-y mainDiv">
        <div class="page-header card-base card-shadow--small"
             style="height: 0; margin-bottom: 10px; padding: 12px 24px 24px;">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top: 0">
                <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.urun.kategori.title")}}</el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.urun.kategori.liste.title")}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.urun.kategori.liste.baslikH1")}}</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-table
                    :data="kategoriList"
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="baslik"
                        label="Başlık"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="olusturan"
                        label="Oluşturan"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="auto">
                    <template slot-scope="scope">
                        <router-link
                                :to="{ path:'/urun/kategori/guncelleme?urunKategoriKodu='+scope.row.urunKategoriKodu}">
                            <el-tooltip :content='$t("src.views.apps.urun.liste.urunduzenle")'
                                        :open-delay="500"
                                        placement="bottom">
                                <el-button
                                        type="warning"
                                        size="mini"
                                        icon="el-icon-edit">
                                </el-button>
                            </el-tooltip>
                        </router-link>
                        &nbsp;
                        <!--<el-link target="_blank" :underline="false" :href="pathh+scope.row.link">-->
                        <!--<el-tooltip :content='$t("src.views.apps.urun.liste.urundetay")' :open-delay="500"-->
                        <!--placement="bottom">-->
                        <!--<el-button-->
                        <!--style="margin-bottom: 5px"-->
                        <!--type="info"-->
                        <!--size="mini"-->
                        <!--icon="mdi mdi-redo-variant">-->
                        <!--</el-button>-->
                        <!--</el-tooltip>-->
                        <!--</el-link>-->
                        &nbsp;
                        <el-tooltip :content='$t("src.views.apps.urun.liste.yayindanKaldir")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    class="durdurBtn"
                                    @click="deleteDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    size="mini"
                                    icon="mdi mdi-pause">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <!--<el-pagination-->
            <!--background-->
            <!--layout="sizes,prev, pager, next, jumper, total"-->
            <!--:total="total"-->
            <!--@size-change="handleSizeChange"-->
            <!--:page-sizes="[10, 20, 50, 100]"-->
            <!--:current-page.sync="page"-->
            <!--:next-click.sync="page"-->
            <!--:prev-click.sync="page"-->
            <!--@next-click="pageChange"-->
            <!--@prev-click="pageChange">-->
            <!--</el-pagination>-->
        </div>
        <el-dialog
                :title='$t("src.views.apps.urun.liste.uyari")'
                :visible.sync="deleteDialogVisible"
                width="30%"
                center>
            <span>'{{selection.baslik}}' {{$t('src.views.apps.urun.liste.uruntaslak')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="kategoriKaldir(selection,selectionIndex,kategoriList), deleteDialogVisible = false"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-close"
                               @click="deleteDialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>

</template>

<script>
    import urunService from '../../../../WSProvider/UrunService'
    import status from '../../../../status'

    let base64 = require('base64_js');
    let userDataArtdoor = "";

    export default {
        name: "Kategoriistesi",
        data() {
            return {
                pathh: "http://artdoor.com.tr/tr/",
                sizes: 10,
                sizesTaslak: 10,
                page: 0,
                pageTaslak: 0,
                postPage: 0,
                postPageTaslak: 0,
                total: null,
                totalTaslak: null,
                kategoriList: [],
                urunlarListTaslak: [],
                deleteDialogVisible: false,
                taslakDialogVisible: false,
                selection: '',
                selectionIndex: '',
            }
        },
        mounted() {
            let state = false;
            if (localStorage.getItem("userDataArtdoor")) {
                userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
                if (userDataArtdoor["tur"]) {
                    if (userDataArtdoor["tur"] === '1' || userDataArtdoor["tur"] === '2')
                        state = true;
                }
            }
            if (!state) {
                this.$store.commit('setLogout');
                this.$router.push("/login");
            } else {
                // this.urunCount();
                // this.getOpsiyonList('1');
                this.getOpsiyonList();
            }
        },
        methods: {
            // handleSizeChange(val) {
            //     this.sizes = val;
            //     this.getOpsiyonList('1');
            // },
            // handleSizeChangeTaslak(val) {
            //     this.sizesTaslak = val;
            //     this.getOpsiyonList('0');
            // },
            // pageChange(val) {
            //     this.postPage = (val - 1) * this.sizes;
            //     this.getOpsiyonList('1');
            // },
            // pageChangeTaslak(val) {
            //     this.postPageTaslak = (val - 1) * this.sizesTaslak;
            //     this.getOpsiyonList('0');
            // },
            // urunCount() {
            //     urunService.urunCount(1).then((response) => {
            //         if (response.status === 200) {
            //             this.total = parseInt(response.data.count);
            //         }
            //     });
            //     urunService.urunCount(0).then((response) => {
            //         if (response.status === 200) {
            //             this.totalTaslak = parseInt(response.data.count);
            //         }
            //     })
            // },
            getOpsiyonList() {
                let self = this;
                urunService.kategoriList().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            if(e.durum === '1'){
                                self.kategoriList.push(e);
                            }
                        })
                    }
                })
            },
            kategoriKaldir(selection, index, list) {
                // console.log(selection);
                urunService.kategoriKaldir(selection.urunKategoriKodu).then((response) => {
                    if (response.status === 200) {
                        list.splice(index, 1);
                        status.Status('success',this,"Kategori başarıyla kaldırıldı.")
                    } else {
                        status.Status(response.status, this)
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }
</style>